import { Filter } from '@/interfaces/filter.interface'
import { APIPermission } from '@/models/api/permission.model'
import { PermissionsServices } from '@/services/modules/permissions.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

interface TempPermission {
    name: string;
    statusId: string;
    typeId: {
        id: string;
    };
}
@Module
export default class PermissionsStore extends VuexModule {
    permissions: object[] = []
    permissionsPaginate: object[] = []
    permissionForm: object|null = null

    @Mutation
    updatePermissions (newPermissions: object[]) {
        this.permissions = newPermissions
    }

    @Mutation
    updateMenusPaginate (newPermissions: object[]) {
        this.permissionsPaginate = newPermissions
    }

    @Mutation
    updatePermission (newPermission: object) {
        this.permissionForm = newPermission
    }

    @Action
    getPermissions () {
        return new Promise((resolve) => {
            PermissionsServices.getPermissions()
                .then(resp => {
                    store.commit('updatePermissions', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getPermissionsPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }
            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            PermissionsServices.getPermissionsPaginate(newParams)
                .then(resp => {
                    store.commit('updateMenusPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getPermissionsById (id: number) {
        return new Promise((resolve) => {
            PermissionsServices.getPermissionsById(id)
                .then(resp => {
                    store.commit('updatePermission', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editPermissions (params: APIPermission) {
        params = new APIPermission(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIPermission)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            PermissionsServices.editPermissions(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createPermissions (params: APIPermission) {
        params = new APIPermission(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIPermission)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            PermissionsServices.createPermissions(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deletePermissions (id: number) {
        return new Promise((resolve) => {
            PermissionsServices.deletePermissions(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
